import { render, staticRenderFns } from "./report-legend.vue?vue&type=template&id=389908a6&scoped=true"
import script from "./report-legend.vue?vue&type=script&lang=js"
export * from "./report-legend.vue?vue&type=script&lang=js"
import style0 from "./report-legend.vue?vue&type=style&index=0&id=389908a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389908a6",
  null
  
)

export default component.exports